import config from "../config/config";

/**
 * Resolve a stored media/file URL for display.
 * Rewrites private S3 object URLs to the backend /assets-s3 proxy so images load
 * without a public bucket policy.
 */
export function resolveMediaUrl(value) {
  if (!value || typeof value !== "string") return "";
  const v = value.trim();
  if (!v) return "";

  if (v.startsWith("data:") || v.startsWith("blob:")) return v;

  const origin = String(config.BASE_URL || "").replace(/\/api\/?$/, "");

  if (/^https?:\/\//i.test(v)) {
    try {
      const u = new URL(v);
      const host = u.hostname.toLowerCase();
      const path = u.pathname || "";

      // Already a proxy URL on another host — keep path, use API origin
      if (path.includes("/assets-s3/")) {
        const idx = path.indexOf("/assets-s3/");
        return `${origin}${path.slice(idx)}${u.search || ""}`;
      }

      // Virtual-hosted: bucket.s3.region.amazonaws.com/key
      if (
        /\.s3[.-][a-z0-9-]+\.amazonaws\.com$/i.test(host) ||
        /\.s3\.amazonaws\.com$/i.test(host)
      ) {
        const key = path.replace(/^\/+/, "");
        if (key) {
          return `${origin}/assets-s3/${key
            .split("/")
            .map((p) => encodeURIComponent(decodeURIComponent(p)))
            .join("/")}`;
        }
      }

      // Path-style: s3.region.amazonaws.com/bucket/key
      if (
        (host.startsWith("s3.") || host.startsWith("s3-")) &&
        host.includes("amazonaws.com")
      ) {
        const parts = path.split("/").filter(Boolean);
        if (parts.length >= 2) {
          const key = parts.slice(1).join("/");
          return `${origin}/assets-s3/${key
            .split("/")
            .map((p) => encodeURIComponent(decodeURIComponent(p)))
            .join("/")}`;
        }
      }
    } catch {
      // fall through
    }
    return v;
  }

  if (v.startsWith("/")) {
    return `${origin}${v}`;
  }
  return v;
}
